/** Holiday API types — mirror the mobile app's holiday.types. */

export interface HolidayQueueInfo {
  id: string;
  name: string;
  providers?: { id: string; display_name: string; profile_image_url: string | null }[];
}

export interface Holiday {
  id: string;
  business_id: string;
  queue_id: string | null;
  start_date: string; // YYYY-MM-DD
  end_date: string;
  reason?: string;
  created_at: string;
  updated_at: string;
  queue?: HolidayQueueInfo;
}

export interface CreateHolidayParams {
  queue_ids: string[];
  start_date: string;
  end_date: string;
  reason?: string;
}

export interface CheckTokensResult {
  has_tokens: boolean;
  total_count: number;
  dates: { date: string; count: number }[];
}

/** A display grouping of holidays sharing reason + date range (one row per queue
 * is returned by the API; we collapse them into a single card). */
export interface HolidayGroup {
  key: string;
  reason?: string;
  start_date: string;
  end_date: string;
  ids: string[];
  queues: string[]; // queue names ("All queues" when queue_id is null)
}

export function groupHolidays(holidays: Holiday[]): HolidayGroup[] {
  const map = new Map<string, HolidayGroup>();
  for (const h of holidays) {
    const key = `${h.reason || ''}|${h.start_date}|${h.end_date}`;
    const name = h.queue?.name || (h.queue_id ? 'Queue' : 'All queues');
    const g = map.get(key);
    if (g) { g.ids.push(h.id); if (!g.queues.includes(name)) g.queues.push(name); }
    else map.set(key, { key, reason: h.reason, start_date: h.start_date, end_date: h.end_date, ids: [h.id], queues: [name] });
  }
  return Array.from(map.values()).sort((a, b) => a.start_date.localeCompare(b.start_date));
}

export const fmtHolidayDate = (d: string): string =>
  new Date(d + 'T00:00:00').toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
